import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import * as MesAct from '../../Actions/MesActions';
import { connect } from 'react-redux';
import { mapStateToPropsWrapper } from '../CaptureErreurs';
import { obtenirPrestation } from '../../App_Code/API';
import SensCommunication from '../../App_Data/SensCommunication';
import IconeBureau from '../../App_Data/IconeBureau';
import { toCalendrier, fromNow } from '../../App_Code/Utils';

const Icone = ({ path, couleur }) => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={20} height={20} style={{filter: "invert(1)"}}>
        <image xlinkHref={path} width={20} height={20}/>
    </svg>
);

class LigneMessageNG extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Presta: '',
        };
    }

    componentWillMount() {
        const { Prest } = this.props.Mes;
        obtenirPrestation(Prest).then((prestation) => {
            this.setState({ Presta: prestation });
        });
    }


    render() {
        const {
            SensCom, DateSaisie, Ind1, Ind2, Bureau, LibBureau, LibPrest, Objet, Memo, NumAuto, NumAff, VuParClient, Attachement,
        } = this.props.Mes;
        const { Presta } = this.state;
        const sensCom = SensCommunication(SensCom);
        return (
            <tr
                className={`clickable-row ${VuParClient === 0 ? 'table-warning' : ''}`}
                title={Memo}
                onClick={() => {
                    this.props.actions.mesMarquerVuParClient(NumAuto);
                    this.props.history.push({
                        pathname: '/MaMessagerie/Message',
                        state: { NumAuto },
                    });
                }}
            >
                <td><i className={sensCom.Icone} title={sensCom.Type} /></td>
                <td>{VuParClient === 0 ? fromNow(DateSaisie) : toCalendrier(DateSaisie)}</td>
                <td>
                    {Ind1.Nom}
                </td>
                <td className="text-center">
                    <IconeBureau idBureau={Bureau} title={LibBureau} />
                </td>
                <td className="d-flex justify-content-center align-self-stretch">
                    { Presta && Presta.Icone ? 
                        <div className="d-flex align-items-center justify-content-center align-middle" title={LibPrest} style={{ height: 22, width: 22, borderRadius: '50%', backgroundColor: Presta.Couleur }}>
                            <Icone path={Presta.Icone} couleur={Presta.Couleur} /> {" "}
                        </div> :
                        <div className="d-flex align-items-center justify-content-center" style={{ height: 22, width: 22, color: "#6c757d" }} title={LibPrest}>
                            <svg width="20" height="20" viewBox="0 0 16 16" className="bi bi-question-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                            </svg>
                        </div>
                    }
                </td>
                <td className="font-weight-bold td-truncate">{Objet}</td>
                <td>
                    {Ind2.Nom}
                </td>
                <td className="text-right">
                    {VuParClient === 0 && <span className="badge badge-pill badge-danger">new</span>}
                    {Attachement && <i className="fas fa-paperclip ml-2" title="Pièce jointe" />}
                </td>
                {/* <td className="text-right">{NumAff}</td> */}
            </tr>
        );
    };
}
LigneMessageNG.displayName = 'LigneMessageNG';

function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(MesAct, dispatch) };
}

export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(LigneMessageNG);



// WEBPACK FOOTER //
// ./src/components/MaMess/LigneMessageNG.js